import React from "react";

import { useTranslation } from "utils";

import { DISCARD_CONFIRM_WIDTH, DISCARD_CONFIRM_Z_INDEX } from "consts";

import { AntModal, Button, Typography } from "components";

const PREFIX = "detailedCalculations.";

type DiscardChangesModalProps = {
  open: boolean;
  onKeepEditing: () => void;
  onDiscard: () => void;
  dataTestId: string;
};

/** Asks before unsaved calculation edits are dropped by navigating away. */
export const DiscardChangesModal = ({ open, onKeepEditing, onDiscard, dataTestId }: DiscardChangesModalProps) => {
  const { t } = useTranslation("scenarioAnalysis");

  return (
    <AntModal
      open={open}
      title={t(`${PREFIX}discardTitle`)}
      onCancel={onKeepEditing}
      // Keeps the confirmation above any open drawer (1002).
      zIndex={DISCARD_CONFIRM_Z_INDEX}
      // No X or mask dismissal, so losing edits is deliberate.
      closable={false}
      maskClosable={false}
      footer={null}
      width={DISCARD_CONFIRM_WIDTH}
      data-testid={`${dataTestId}-discard-modal`}
    >
      <Typography variant="paragraph-m" color="grey-600">
        {t(`${PREFIX}discardBodyNavigate`)}
      </Typography>
      <div className="detailed-calculations-confirm-footer">
        <Button type="secondary" className="button-no-min-width" onClick={onKeepEditing} dataTestId={`${dataTestId}-keep-editing`}>
          {t(`${PREFIX}keepEditing`)}
        </Button>
        <Button type="danger" className="button-no-min-width" onClick={onDiscard} dataTestId={`${dataTestId}-discard`}>
          {t(`${PREFIX}discard`)}
        </Button>
      </div>
    </AntModal>
  );
};

export default DiscardChangesModal;
